import { createSelector } from 'reselect';
import { DEALS_TAB } from '../constants/OverviewConstants';
export const getOverview = state => state.overview;
export const getIsAggregatedSubmissionsDataFetching = createSelector([getOverview], overview => overview === null || overview === void 0 ? void 0 : overview.isAggregatedSubmissionsFetching);
export const getIsAggregatedGoalsDataFetching = createSelector([getOverview], overview => overview === null || overview === void 0 ? void 0 : overview.isAggregatedGoalsFetching);
export const getIsOverviewDataFetching = createSelector([getOverview], overview => (overview === null || overview === void 0 ? void 0 : overview.isAggregatedSubmissionsFetching) || (overview === null || overview === void 0 ? void 0 : overview.isAggregatedDealRollupFetching));
export const getIsOverviewDataFetchSuccessful = createSelector([getOverview], overview => overview === null || overview === void 0 ? void 0 : overview.isAggregatedDataFetchSuccessful);
export const getIsInitialOverviewFetchSuccessful = createSelector([getOverview], overview => overview === null || overview === void 0 ? void 0 : overview.isInitialOverviewFetchSuccessful);
export const getSelectedTeamId = state => {
  var _getOverview;
  return (_getOverview = getOverview(state)) === null || _getOverview === void 0 ? void 0 : _getOverview.selectedTeamId;
};
export const getBreadcrumbTrail = state => {
  var _getOverview2;
  return (_getOverview2 = getOverview(state)) === null || _getOverview2 === void 0 ? void 0 : _getOverview2.breadcrumbTrail;
};
export const getDealSidebarId = state => {
  var _getOverview3;
  return (_getOverview3 = getOverview(state)) === null || _getOverview3 === void 0 ? void 0 : _getOverview3.dealSidebar.dealSidebarId;
};
export const getDealSidebarIsForTeam = state => {
  var _getOverview4;
  return !!((_getOverview4 = getOverview(state)) !== null && _getOverview4 !== void 0 && _getOverview4.dealSidebar.isTeam);
};
export const getDefaultDealSidebarTab = state => {
  var _getOverview$dealSide, _getOverview5;
  return (_getOverview$dealSide = (_getOverview5 = getOverview(state)) === null || _getOverview5 === void 0 ? void 0 : _getOverview5.dealSidebar.defaultTab) !== null && _getOverview$dealSide !== void 0 ? _getOverview$dealSide : DEALS_TAB;
};